import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import './BuyerPages.css';

/** Basic account view. Identity comes from the engine's /auth/me, never from storage. */
export function AccountPage() {
  const { user } = useAuth();
  if (!user) return null;

  const name = [user.firstName, user.lastName].filter(Boolean).join(' ');

  return (
    <div className="buyer__page">
      <header className="buyer__header">
        <h1 className="buyer__title display">My account</h1>
        <p className="buyer__lede">Your Voleto profile and ticket history.</p>
      </header>

      <section className="card buyer__details">
        <dl className="buyer__facts">
          <div>
            <dt>Name</dt>
            <dd>{name || '-'}</dd>
          </div>
          <div>
            <dt>Email</dt>
            <dd className="mono">{user.email}</dd>
          </div>
          <div>
            <dt>Account type</dt>
            <dd className="buyer__role">{user.role}</dd>
          </div>
          <div>
            <dt>Email verified</dt>
            <dd className={user.verified ? 'buyer__yes' : 'buyer__no'}>
              {user.verified ? 'Verified' : 'Not verified'}
            </dd>
          </div>
        </dl>
      </section>

      <section className="card buyer__links">
        <h2 className="buyer__section-title">Tickets</h2>
        <p>Every order you placed while signed in, with QR codes ready to scan.</p>
        <Link to="/account/orders" className="button button--primary">
          View my orders
        </Link>
      </section>
    </div>
  );
}
